var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ErrorMessage from './ErrorMessage';
import { translate } from '../../../strings/i18n';
import useGetImages from '../../../hooks/useGetImages';
import { BUSINESS_ERROR_CODES } from '../../../const/status-and-error-codes';
var ChangePaymentDueDateErrors = function (_a) {
    var _b, _c;
    var errorCode = _a.errorCode;
    var _d = useGetImages(), error = _d.error, ladyWarning = _d.ladyWarning;
    var defaultError = {
        image: error,
        id: 'cpdd-error-message',
        title: translate('errorMessages.troubleRetrievingInformation'),
        subTitle: translate('errorMessages.tryAgainLater')
    };
    var errorsList = [
        {
            errorListProps: {
                id: 'cpdd-period-restiction-error-message',
                image: ladyWarning,
                title: translate('errorMessages.dueDateChangePeriodRestriction.title'),
                subTitle: translate('errorMessages.dueDateChangePeriodRestriction.subTitle')
            },
            rule: errorCode === BUSINESS_ERROR_CODES.DATE_ALREADY_CHANGED
        },
        {
            errorListProps: {
                id: 'cpdd-not-eligible',
                image: ladyWarning,
                subTitle: translate('errorMessages.notEligible.body'),
                title: translate('errorMessages.notEligible.title')
            },
            rule: Boolean(errorCode) &&
                errorCode !== BUSINESS_ERROR_CODES.DATE_ALREADY_CHANGED
        }
    ];
    return (_jsx("div", __assign({ "data-cy": "message-box-container" }, { children: _jsx(ErrorMessage, __assign({}, ((_c = (_b = errorsList.find(function (_a) {
            var rule = _a.rule;
            return rule;
        })) === null || _b === void 0 ? void 0 : _b.errorListProps) !== null && _c !== void 0 ? _c : defaultError))) })));
};
export default ChangePaymentDueDateErrors;
